import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=ec9edcf6&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=ec9edcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9edcf6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Dashboard.vue
// module id = null
// module chunks = 